import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useAnimatedCollapse } from '../../../hooks';
import { CollapseAnimationStyles } from '../../../styled';
import { ArrowUp } from '../icons';

interface Props {
  title: ReactNode;
  children?: ReactNode;
  openByDefault?: boolean;
  dataTestId?: string;
}

const Wrapper = styled.div`
  border: 1px solid ${(p) => p.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
`;

const HeaderWrapper = styled.div`
  display: flex;
  padding: 24px 24px 24px 52px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const CardHeader = styled.h2`
  margin: 0;
  ${(p) => p.theme.typography.title};
  text-align: left;
`;

const HeaderIconWrapper = styled.div<{ isOpenContent: boolean }>`
  transition: transform 0.15s ease-out;
  ${(props) => !props.isOpenContent && 'transform: rotate(180deg)'};
`;

const ContentWrapper = styled.div<{ contentHeight: number }>`
  ${(props) => CollapseAnimationStyles(props.contentHeight)};
  padding: ${(props) => (props.contentHeight ? '0 24px 24px' : '0 24px')};
`;

const ToggleBox = ({ title, children, openByDefault = false, dataTestId }: Props): JSX.Element => {
  const { collapseHandle, contentHeight, ref } = useAnimatedCollapse({ isOpen: openByDefault });

  return (
    <Wrapper data-test-id={dataTestId}>
      <HeaderWrapper onClick={collapseHandle}>
        <CardHeader>{title}</CardHeader>
        <HeaderIconWrapper isOpenContent={!!contentHeight}>
          <ArrowUp />
        </HeaderIconWrapper>
      </HeaderWrapper>
      <ContentWrapper contentHeight={contentHeight} ref={ref}>
        {children}
      </ContentWrapper>
    </Wrapper>
  );
};

export default ToggleBox;
